// src/components/canine-teeth/ImageUpload.js

import React, { useState, useEffect, useCallback } from 'react';
import ImageSelector from './ImageSelector';
import '../tools.css';
import SavedSessionsGallery from './SavedSessionsGallery';
import { auth, db } from '../../firebase';
// eslint-disable-next-line no-unused-vars
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';

function ImageUpload() {
  const [userEmail, setUserEmail] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [step, setStep] = useState(1);
  const [tipo, setTipo] = useState('');
  const [posizione, setPosizione] = useState('');
  const [loadedSession, setLoadedSession] = useState(null);
  const [sesso, setSesso] = useState('');
  const [realAge, setRealAge] = useState('');
  //const [regione, setRegione] = useState('');

  // eslint-disable-next-line no-unused-vars
  const [user, setUser] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [userInfo, setUserInfo] = useState(null);

  const [sessionsCount, setSessionsCount] = useState(0);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const navigate = useNavigate();

  const handleSaveSessoAndRegione = useCallback(() => {
    if (sesso) {
      setStep(3); // Passa allo step successivo
    } else {
      alert('Plase select gender and region');
    }
  }, [sesso]);

  // Gestione dello stato di autenticazione
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        setUserEmail(user.email);
        try {
          const docRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserInfo(docSnap.data());
          } else {
            console.warn('Nessun documento utente trovato!');
            setUserInfo(null);
          }
        } catch (error) {
          console.error('Errore nel recuperare i dati utente:', error);
          setUserInfo(null);
        }
      } else {
        setUser(null);
        navigate('/');
      }
      setIsAuthLoading(false); // Autenticazione completata
    });

    return () => unsubscribe();
  }, [navigate]);

  // Funzione di logout
  // const handleLogout = useCallback(async () => {
  //   try {
  //     await signOut(auth);
  //     navigate('/');
  //   } catch (error) {
  //     console.error('Errore durante il logout:', error);
  //     alert('Si è verificato un errore durante il logout. Riprova.');
  //   }
  // }, [navigate]);

  // Gestione della selezione dell'immagine
  const handleImageChange = useCallback((e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setStep(2);
    }
  }, []);


  // Seleziona una sessione salvata
  const handleSelectSession = useCallback((session) => {
    setImageFile(null);
    setTipo(session.tipo || '');
    setPosizione(session.posizione || '');
    setLoadedSession(session);
    setStep(3);
  }, []);

  // Aggiorna il conteggio delle sessioni
  const updateSessionsCount = useCallback(() => {
    setSessionsCount((prev) => prev + 1);
  }, []);

  // Gestione dello stato di caricamento dell'autenticazione
  if (isAuthLoading) {
    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
                <p>Loading... Syncing profile info</p>
            </div>
        </div>
    );
}

  // Rendering condizionale in base allo stato
  return (
    <div className="tool-container">
      {step === 1 && (
        <div className="upload-step">
          <h2 className="step-title">Step 1: Upload Image</h2>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {imageFile && <p>Immagine selezionata: {imageFile.name}</p>}
        </div>
      )}

      {step === 2 && (
        <div className="selection-step">
          <h2 className="step-title">Step 2: Select Gender</h2>
          <h4>Immagine selezionata: {imageFile.name}</h4>

          <div className="selection-group">
            <h4>Select Sex</h4>
            <label>
              <input
                type="radio"
                value="M"
                checked={sesso === 'M'}
                onChange={(e) => setSesso(e.target.value)}
              />
              Male
            </label>
            <br />
            <label>
              <input
                type="radio"
                value="F"
                checked={sesso === 'F'}
                onChange={(e) => setSesso(e.target.value)}
              />
              Female
            </label>
          </div>

          <div className="selection-group">
            <h4>Real Age (Optional)</h4>
            <input
              type="number"
              value={realAge}
              onChange={(e) => setRealAge(e.target.value)}
              placeholder="Enter real age"
              min="0"
              step="0.1"
            />
          </div>

          <button onClick={handleSaveSessoAndRegione} className="save-button">
            Save Data
          </button>
        </div>
      )}

        { step >= 3 && (imageFile || loadedSession) && (
          <ImageSelector
            imageFile={imageFile}
            userEmail={userEmail}
            sesso={sesso}
            realAge={realAge}
            tipo={tipo}
            posizione={posizione}
            selectionRequired={false}
            maxTotalPoints={2}
            colorCategories={['blue']}
            categoryColors={{ blue: 'blue' }}
            passCategoryToAnnotation={true}
            maxPointsPerCategory={{ blue: 3 }}
            useLeftRightInNames={true}
            categoriesToAnnotate={['blue']}
            loadedSession={loadedSession}
            updateSessionsCount={updateSessionsCount}
          />
        )}

      {step === 1 && (
        <SavedSessionsGallery
          onSelectSession={handleSelectSession}
          sessionsCount={sessionsCount}
          userEmail={userEmail}
        />
      )}
    </div>
  );
}

export default ImageUpload;
